import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-await-notification-modal',
	templateUrl: './await-notification-modal.component.html',
	styleUrls: ['./await-notification-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AwaitNotificationModalComponent implements OnInit {
	private modalCtrl = inject(ModalController);
	T;
	constructor() {}
	ngOnInit(): void {}

	static async show(modalCtrl: ModalController): Promise<boolean> {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height item-modal',
			component: AwaitNotificationModalComponent,
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: false,
		});
		await modal.present();

		const result = await modal.onDidDismiss();
		await sleep(100);
		return result.data;
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
